import type {
    CoopContentPageSize,
    CoopLayoutSize,
} from '../../../../utility/coopSwiperBreakpoints';
import type { PriceType } from '../../models/priceData/priceData';
import type { CncNavigatePayload } from '../slices/ui/uiActions';

export interface SharedUiState {
    hasSideBar: boolean;
    hideFooterMobile: boolean;
    hideSubMenu: boolean;
    layoutSize: CoopLayoutSize;
    contentPageSize: CoopContentPageSize;
    preferredPriceType?: PriceType;
}

export interface CncUiState {
    stepTrail: CncNavigatePayload[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reloadOnClose: boolean;
}

export enum CncStep {
    MiniCart = 'MiniCart',
    TimeSlots = 'TimeSlots',
    Map = 'Map',
    PostalCodeSelector = 'PostalCodeSelector',
    PostalCodePreview = 'PostalCodePreview',
}
